import HttpClient from './http-clients/portaljad'

const baseUrl = 'clientes'

export default class ClienteService {
  static async findAll() {
    try {
      const { data } = await HttpClient.get(baseUrl)
      return data.body
    } catch (error) {
      throw error.response.data
    }
  }

  static async findById(clienteId) {
    try {
      if (!clienteId) {
        return undefined
      }
      const { data } = await HttpClient.get([baseUrl, clienteId].join('/'))
      return data.body
    } catch (error) {
      throw error.response.data
    }
  }

  static async findByUsuariosPrimeId(usuarioId) {
    try {
      const { data } = await HttpClient.get([baseUrl, 'cliente-usuarios-prime', usuarioId].join('/'))
      return data.body
    } catch (error) {
      throw error.response.data
    }
  }

  static async save(multipart) {
    try {
      const { data } = await HttpClient.post(baseUrl, multipart, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      return data
    } catch (error) {
      throw error.response.data
    }
  }

  static async editWithMultipart(clienteId, multipart) {
    try {
      const { data } = await HttpClient.put([baseUrl, 'with-multipart', clienteId].join('/'), multipart, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      return data
    } catch (error) {
      throw error.response.data
    }
  }

  static async edit(clienteId, cliente) {
    try {
      const { data } = await HttpClient.put([baseUrl, clienteId].join('/'), cliente)
      return data
    } catch (error) {
      throw error.response.data
    }
  }

  static async switchAtivo(clienteId) {
    try {
      const { data } = await HttpClient.put([baseUrl, 'switch-ativo', clienteId].join('/'))
      return data
    } catch (error) {
      throw error.response.data
    }
  }

  static async delete(clienteId) {
    try {
      await HttpClient.delete([baseUrl, clienteId].join('/'))
    } catch (error) {
      throw error.response.data
    }
  }
}